import React from "react";
import styles from './About.module.css';
import img1 from '../../Compenents/assets/ss.png';
import img2 from '../../Compenents/assets/dev.png';
import img3 from '../../Compenents/assets/graph.png';

const About = () => {
    return (
        <div id="about" className={styles.about}>
            <div className="container wow bounceInDown">
                <h1>Qui Nous sommes?</h1>
                <div className={styles.cont}>
                    <div className={styles.text}>
                        <p>Nous formons une équipe de Développeur Web,
                            Designer Web et Graphiste. On sait que le design
                            et la présentations digitale sont primordiales pour que
                            votre Entreprise avance à jour. On est là pour collaborer!
                            Ayez confiance en nos compétences.
                        </p>
                    </div>
                    <div className={styles.img}></div>
                </div>

            </div>
            <div className={styles.abt}>
                <div className="container">
                    <div className={`${styles.abtcont} wow bounceIn`}>
                        <div>
                            <img src={img2} alt="" />
                            <h3>Développeur Web</h3>
                        </div>
                        <div>
                            <img src={img1} alt="" />
                            <h3>Designer Web</h3>
                        </div>
                        <div>
                            <img src={img3} alt="" />
                            <h3>Graphiste</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About;
